module.exports = __webpack_public_path__ + "img/crizal-forte.eeb122de.svg";